import * as React from 'react';
import {observer} from 'mobx-react';
import ActionsMenu, {ActionItem} from '../../../../components/Common/ActionsMenu';
import {addToMenu, removeFromMenu} from '../actions/Collection';
import {rootExec} from '../constants/constants';
import {getLocalizedText, textConst, texts} from '../../../../constants/TextConst';
import {MoveSubmenu} from './MoveSubMenu';
import {startTitleEdit} from '../../Common/actions/Field';
import {useCallback} from 'react';
import arrowLeftImage from '../../../../images/arrow_left.png';

interface MenuProps {
    field: any;
    open: boolean;
}

const PersonalActionsMenu = observer((props: MenuProps) => {
    const {field, open} = props;

    const changeName = useCallback(() => {
        startTitleEdit(field);
    }, [field]);

    if (!open) return null;

    return (
        <ActionsMenu open={open}>
            <div className="actions1">
                {field.type === 'tab' && (
                    <ActionItem
                        title={getLocalizedText(texts.personalFolderAdd)}
                        onActionClick={() => addToMenu(field)}
                    />
                )}
                {field.exec !== rootExec && (
                    <>
                        <ActionItem
                            title={getLocalizedText(texts.myMenuDelete)}
                            onActionClick={() => removeFromMenu(field)}
                        />
                        <ActionItem
                            title={getLocalizedText(texts.move)}
                            icon={<img alt={textConst.moreAlt} src={arrowLeftImage} />}
                        >
                            <MoveSubmenu
                                field={field}
                                outsideClickIgnoreClass={'action-tab-open'}
                            />
                        </ActionItem>
                        <ActionItem
                            title={getLocalizedText(texts.rename)}
                            onActionClick={changeName}
                        />
                    </>
                )}
            </div>
        </ActionsMenu>
    );
});

export default PersonalActionsMenu;
